import { pxToRem } from '@intigral/utils/lib/helpers/pxToRem';
interface IconProps extends React.SVGProps<SVGSVGElement> {
    width?: number | string;
    height?: number | string;
}

export const CameraPhone = ({ width = 60, height = 60, ...rest }: IconProps) => {
    const computedWidth = typeof width === 'number' ? pxToRem(width) : width;
    const computedHeight = typeof height === 'number' ? pxToRem(height) : height;

    return (
        <svg
            width={computedWidth}
            height={computedHeight}
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.3333 43.3332V44.9998C28.3333 45.9203 29.0795 46.6665 30 46.6665C30.9205 46.6665 31.6667 45.9203 31.6667 44.9998V43.3332C31.6667 42.4127 30.9205 41.6665 30 41.6665C29.0795 41.6665 28.3333 42.4127 28.3333 43.3332Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 11.6665C15 8.90508 17.2386 6.6665 20 6.6665H40C42.7614 6.6665 45 8.90508 45 11.6665V48.3332C45 51.0946 42.7614 53.3332 40 53.3332H20C17.2386 53.3332 15 51.0946 15 48.3332V11.6665ZM40 9.99984C40.9205 9.99984 41.6667 10.746 41.6667 11.6665V48.3332C41.6667 49.2536 40.9205 49.9998 40 49.9998H20C19.0795 49.9998 18.3333 49.2536 18.3333 48.3332V11.6665C18.3333 10.746 19.0795 9.99984 20 9.99984H40Z"
                fill="white"
            />
            <path d="M21.668 16.6665V23.3332H25.0013V19.9998H28.3346V16.6665H21.668Z" fill="#FF6A39" />
            <path d="M38.3346 16.6665V23.3332H35.0013V19.9998H31.668V16.6665H38.3346Z" fill="#FF6A39" />
            <path d="M21.668 33.3332V26.6665H25.0013V29.9998H28.3346V33.3332H21.668Z" fill="#FF6A39" />
            <path d="M38.3346 33.3332V26.6665H35.0013V29.9998H31.668V33.3332H38.3346Z" fill="#FF6A39" />
        </svg>
    );
};
